module.exports = __webpack_public_path__ + "img/benefit-02-member.5f59265c.png";